import { createSelector } from 'reselect'
import getSummaryDataByMemberIdSquadSelector from 'modules/squad/redux/selectors/get-summary-data-by-member-id'

const hasSummaryDataByMemberIdSquadSelector = memberId => createSelector(
  getSummaryDataByMemberIdSquadSelector(memberId),
  /**
   * @param {import('modules/squad/types').GetSquadSummaryResp} squadSummaryData
   */
  (squadSummaryData) => {
    return !!(
      squadSummaryData?.most_popular_sample?.variant_id ||
      squadSummaryData?.most_recent_liked_sample?.variant_id ||
      squadSummaryData?.items_you_both_loved?.length
    )
  }
)

export default hasSummaryDataByMemberIdSquadSelector
